import { Component, OnInit} from '@angular/core';
import { PreregistroService } from '../../../services/preregistro.service';
import { SweetMessage } from '../../../config/sweet-message';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Validation } from '../../../config/validation';

@Component({
  selector: 'new-registro',
  templateUrl: './new-registro.component.html',
  styleUrls: ['./new-registro.component.css'],
  providers: [PreregistroService]
})
export class NewRegistroComponent implements OnInit {
	public loading: boolean;
	public msgSweet: SweetMessage;
	public vl: Validation;
	public data: any = {
		dni: "",
		nombres: "",
		apellidos: "",
		// usuario: "",
		correo: "",
		telefono: "",
		recaptcha: ""
	};

	constructor(
		private preregistroService: PreregistroService,
		// private recaptchaV3Service: ReCaptchaV3Service,
	){
		this.loading = false;
		this.msgSweet = new SweetMessage();
		this.vl = new Validation();
	}

	ngOnInit() {
		//
	}

	isValidForm(){
		if( this.data.dni.trim() == "" ){
			this.msgSweet.showMessage('error-message', "Ingrese la CI/RUC del negocio");
			return false;
		}
		if( this.data.dni.trim().length < 10 ){
			this.msgSweet.showMessage('error-message', "El campo CI/RUC no puede ser menor que 10 dígitos");
			return false;
		}
		if( this.data.dni.trim().length > 10 && this.data.dni.trim().length < 13 ){
			this.msgSweet.showMessage('error-message', "El campo CI/RUC debe de tener 13 dígitos");
			return false;
		}
		if( this.data.dni.trim().length > 13 ){
			this.msgSweet.showMessage('error-message', "El campo CI/RUC no puede ser mayor que 13 dígitos");
			return false;
		}
		if( this.data.dni.trim().length == 10 && !this.vl.validCI(this.data.dni) ){
			this.msgSweet.showMessage('error-message', "El número de CI/RUC es inválido");
			return false;
		}
		if( this.data.dni.trim().length == 13 && !this.vl.validRUC(this.data.dni) ){
			this.msgSweet.showMessage('error-message', "El número de CI/RUC es inválido");
			return false;
		}
		if( this.data.nombres.trim() == "" ){
			this.msgSweet.showMessage('error-message', "Ingrese los nombres");
			return false;
		}
		if( this.data.apellidos.trim() == "" ){
			this.msgSweet.showMessage('error-message', "Ingrese los apellidos");
			return false;
		}
		if( this.data.telefono.trim() == "" ){
			this.msgSweet.showMessage('error-message', "Ingrese el número de teléfono");
			return false;
		}
		if( this.data.correo.trim() == "" ){
			this.msgSweet.showMessage('error-message', "Ingrese el correo");
			return false;
		}
		if( this.data.recaptcha.trim() == "" ){
			this.msgSweet.showMessage('error-message', "Seleccione la opción de 'No soy un robot'");
			return false;
		}

		return true;
	}

	resolved(captchaResponse: string) {
		this.data.recaptcha = captchaResponse;
    }

	guardar(reCaptcha){
		if( !this.isValidForm() ){
			return false;
		}

		this.loading = true;
		this.preregistroService.save(this.data).subscribe(
			res => {
				this.msgSweet.showMessage('success-message', 'Se ha registrado correctamente, en un momento le llegará a su correo los accesos');
				this.loading = false;
				this.data = {
					dni: "",
					nombres: "",
					apellidos: "",
					// usuario: "",
					correo: "",
					telefono: "",
					recaptcha: ""
				};
				reCaptcha.reset();
			},
			err => {
				this.msgSweet.showMessage('error-message', (err ? err : "Ha ocurrido un error"));
				this.loading = false;
			}
		);
	}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/login/new-registro/new-registro.component.ts